import { useState, useEffect, useRef, useMemo } from 'react';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useTranslation } from 'react-i18next';
import './information.css'
import axios from 'axios';

const DEFAULT_AD_ID = 'default-announcement';

function Information() {
  const [arrAdvertisements, setArrAdvertisements] = useState([]);
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState("fade-in");
  const [tInformation] = useTranslation("information");

  const scrollRef = useRef(null);
  let currentLng = "es";
  localStorage.getItem("lng") ? currentLng = `${localStorage.getItem("lng")}` : currentLng = 'es';

  const defaultAdvertisement = useMemo(() => ({
    id_advertisement: DEFAULT_AD_ID,
    type: "advertisement",
    title_es: tInformation("defaultAnnouncement.title"),
    desc_es: tInformation("defaultAnnouncement.description"),
    title_en: tInformation("defaultAnnouncement.title"),
    desc_en: tInformation("defaultAnnouncement.description"),
  }), [tInformation]);

  const displayAdvertisements = useMemo(() => {
    const fromApi = arrAdvertisements.filter(
      (item) => item.id_advertisement !== DEFAULT_AD_ID
    );
    return [defaultAdvertisement, ...fromApi];
  }, [arrAdvertisements, defaultAdvertisement]);

  const triggerFade = (newIndex) => {
    setFade("fade-out");

    setTimeout(() => {
      setIndex(newIndex);
      setFade("fade-in");
    }, 250);
  };

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement`
      const response = await axios.get(url, {headers: {
        Authorization: process.env.REACT_APP_PUBLIC_KEY
      }});
      const advertisements = (response.data.data || []).filter(item => item.type === "advertisement");
      setArrAdvertisements(advertisements);
    } catch (error) {
      console.log(error);
      setArrAdvertisements([]);
    }
  }

  useEffect(() => {
    if (displayAdvertisements.length <= 1) return;

    const interval = setInterval(() => {
      triggerFade((index + 1) % displayAdvertisements.length);
    }, 15000);

    return () => clearInterval(interval);
  }, [index, displayAdvertisements.length]);

  const prevSlide = () => {
    const newIndex = index === 0 ? displayAdvertisements.length - 1 : index - 1;
    triggerFade(newIndex);
  };

  const nextSlide = () => {
    const newIndex = (index + 1) % displayAdvertisements.length;
    triggerFade(newIndex);
  };

  useEffect(() => {
    if (displayAdvertisements.length === 0) return;

    const el = scrollRef.current;
    if (!el) return;

    el.scrollLeft = 0;

    // duración de 10s
    const duration = window.innerWidth < 600 ? 15000 : 10000;
    const start = el.scrollLeft;
    const end = el.scrollWidth - el.clientWidth;
    const startTime = performance.now();

    const animate = (time) => {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);

      el.scrollLeft = start + (end * progress);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [index, displayAdvertisements.length]);


  const showCarouselControls = displayAdvertisements.length > 1;

  return(
    <div className='information-container-home'>
      {showCarouselControls && (
        <div className='arrow-left' onClick={prevSlide}><FiChevronLeft /></div>
      )}

      <div className={`info-text ${fade}`} ref={scrollRef}>
        {displayAdvertisements[index] && (
          <p className='title'>
            {currentLng === "es" ? displayAdvertisements[index].title_es : displayAdvertisements[index].title_en}
          </p>
        )}

        {displayAdvertisements[index] && (
          <p>
            {currentLng === "es" ? displayAdvertisements[index].desc_es : displayAdvertisements[index].desc_en}
          </p>
        )}
      </div>

      {showCarouselControls && (
        <div className='arrow-right' onClick={nextSlide}><FiChevronRight /></div>
      )}
    </div>
  )
}

export default Information;